import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  toShowLabel = this.env.envVariables.companyName;

  constructor(private env: EnvironmentService) { }

  ngOnInit(): void {
  }

}
